import { useMemo } from "react"
import { useNavigate, useSearchParams } from "react-router"
import { useTranslation } from "react-i18next"

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@f2e/ui/components/base"

type VerificationStatus =
  | "success"
  | "invalid"
  | "expired"
  | "rate_limited"
  | "not_found"
  | "unknown"

const ALLOWED_STATUS = new Set([
  "success",
  "invalid",
  "expired",
  "rate_limited",
  "not_found",
])

const NotificationEmailVerificationResult = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const status = useMemo<VerificationStatus>(() => {
    const raw = searchParams.get("status") || ""
    return ALLOWED_STATUS.has(raw)
      ? (raw as Exclude<VerificationStatus, "unknown">)
      : "unknown"
  }, [searchParams])

  const title = t(`common.emailVerification.status.${status}.title`)
  const description = t(`common.emailVerification.status.${status}.description`)

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50 dark:bg-slate-950">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{description}</p>
          <Button
            type="button"
            onClick={() => navigate("/login", { replace: true })}
          >
            {t("common.emailVerification.backToLogin")}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default NotificationEmailVerificationResult
